var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForgejoLogo = function SvgForgejoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 212"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 168V70a50 50 0 0 1 50-50h20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 168v-30a50 50 0 0 1 50-50h20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 20,
    r: 18,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 88,
    r: 18,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 180,
    r: 18,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 15
  }))));
};
export default SvgForgejoLogo;